import { IMG } from "./i18n";

export const TREATMENTS = {
  "mesoterapia-estetica": {
    service: { it: "Mesoterapia estetica", en: "Aesthetic mesotherapy" },
    img: IMG.realBack,
    pos: "50% 45%",
    it: {
      kicker: "Trattamento corpo",
      title: "Mesoterapia estetica",
      lead: "Un trattamento mirato per una pelle più compatta e levigata, pensato per chi vuole contrastare ritenzione e inestetismi della cellulite su gambe e glutei.",
      forWho: ["Ritenzione e gambe pesanti", "Inestetismi della cellulite e pelle a buccia d'arancia", "Pelle poco tonica su cosce e glutei", "Chi vuole potenziare un percorso corpo"],
      steps: [
        ["Consulenza", "Valutiamo insieme le zone da trattare, le tue abitudini e l'obiettivo da raggiungere."],
        ["Protocollo su misura", "Scegliamo i prodotti e la frequenza delle sedute più adatti alla tua pelle."],
        ["Seduta", "Il trattamento si concentra sulle zone indicate, in un ambiente curato e igienizzato."],
        ["Mantenimento", "Ti diamo i consigli da seguire a casa per prolungare e valorizzare i risultati."],
      ],
      faq: [
        ["A chi è indicata la mesoterapia estetica?", "A chi desidera migliorare l'aspetto di ritenzione, cellulite e pelle poco tonica. Durante la consulenza Gioia valuta con te se è il trattamento giusto."],
        ["Quante sedute servono?", "Dipende dalla zona e dall'obiettivo: il numero di sedute e la loro frequenza vengono definiti nella prima consulenza, in base alla tua pelle."],
        ["Posso tornare subito alle mie attività?", "In genere sì. Ti indicheremo le piccole attenzioni da seguire nelle ore successive alla seduta."],
        ["Si può abbinare ad altri trattamenti?", "Sì: spesso la abbiniamo a un massaggio drenante o al trattamento corpo snellente per un percorso più completo."],
        ["Ci sono controindicazioni?", "Come per ogni trattamento, alcune condizioni richiedono attenzione. Per questo ogni percorso inizia con una consulenza in cui raccogliamo tutte le informazioni necessarie."],
      ],
    },
    en: {
      kicker: "Body treatment",
      title: "Aesthetic mesotherapy",
      lead: "A targeted treatment for firmer, smoother skin, designed for those who want to address water retention and the appearance of cellulite on legs and glutes.",
      forWho: ["Water retention and heavy legs", "Cellulite and orange-peel skin", "Lack of tone on thighs and glutes", "Boosting a body treatment programme"],
      steps: [
        ["Consultation", "Together we assess the areas to treat, your habits and your goal."],
        ["Tailored protocol", "We choose the products and session frequency best suited to your skin."],
        ["Session", "The treatment focuses on the chosen areas, in a calm and sanitised environment."],
        ["Aftercare", "We give you home-care tips to extend and enhance the results."],
      ],
      faq: [
        ["Who is aesthetic mesotherapy for?", "For anyone who wants to improve water retention, cellulite and lack of tone. During the consultation Gioia will confirm whether it is the right treatment for you."],
        ["How many sessions do I need?", "It depends on the area and the goal: the number and frequency of sessions are defined during your first consultation."],
        ["Can I go back to my day straight away?", "Usually yes. We will tell you the small precautions to follow in the hours after the session."],
        ["Can it be combined with other treatments?", "Yes: we often pair it with a draining massage or the slimming body treatment for a complete programme."],
        ["Are there contraindications?", "As with any treatment, some conditions need care. That is why every programme starts with a consultation."],
      ],
    },
  },
  "mesoporazione-estetica": {
    service: { it: "Mesoporazione estetica", en: "Aesthetic mesoporation" },
    img: "/images/mesoporazione-estetica.jpg",
    pos: "50% 45%",
    it: {
      kicker: "Trattamento viso",
      title: "Mesoporazione estetica",
      lead: "La \"mesoterapia senza aghi\": impulsi delicati aiutano i principi attivi a penetrare più in profondità, per una pelle più idratata, tonica e luminosa, senza fastidi né tempi di recupero.",
      forWho: ["Pelle spenta, disidratata o stanca", "Piccole linee di disidratazione", "Viso poco tonico e incarnato non uniforme", "Una coccola di bellezza prima di un evento"],
      steps: [
        ["Analisi della pelle", "Valutiamo insieme lo stato della tua pelle e cosa le serve in questo momento."],
        ["Detersione e scelta degli attivi", "Prepariamo il viso e scegliamo i principi attivi più adatti: idratanti, illuminanti, rassodanti o lenitivi."],
        ["Mesoporazione", "Il manipolo scorre delicatamente su viso, collo e décolleté: la sensazione è piacevole, quasi un massaggio."],
        ["Consigli per casa", "Ti suggeriamo la routine e la crema Gioia Skincare più adatte per prolungare i risultati."],
      ],
      faq: [
        ["La mesoporazione usa aghi?", "No. Il trattamento non usa aghi: gli impulsi rendono la pelle temporaneamente più permeabile, così gli attivi applicati arrivano più in profondità."],
        ["È fastidiosa o dolorosa?", "No, è un trattamento delicato e piacevole. Molte clienti lo trovano rilassante."],
        ["Quando si vedono i risultati?", "Già dopo la prima seduta la pelle appare più idratata e luminosa. Con un percorso costante migliorano anche tono e compattezza."],
        ["Quante sedute servono?", "Dipende dalla pelle e dall'obiettivo: il numero di sedute e la frequenza vengono definiti nella prima consulenza."],
        ["Posso truccarmi dopo?", "Non ci sono tempi di recupero. Nelle ore successive consigliamo di evitare il trucco pesante e di lasciare respirare la pelle."],
        ["Ci sono controindicazioni?", "Alcune condizioni richiedono attenzione: per questo ogni percorso inizia con una consulenza in cui raccogliamo tutte le informazioni necessarie."],
      ],
    },
    en: {
      kicker: "Facial treatment",
      title: "Aesthetic mesoporation",
      lead: "\"Needle-free mesotherapy\": gentle pulses help active ingredients penetrate deeper, for more hydrated, toned and radiant skin, with no discomfort and no downtime.",
      forWho: ["Dull, dehydrated or tired skin", "Fine dehydration lines", "Lack of tone and uneven complexion", "A beauty treat before a special event"],
      steps: [
        ["Skin analysis", "Together we assess your skin and what it needs right now."],
        ["Cleansing and actives", "We prepare the skin and choose the most suitable actives: hydrating, brightening, firming or soothing."],
        ["Mesoporation", "The handpiece glides gently over face, neck and décolleté: it feels pleasant, almost like a massage."],
        ["Home-care tips", "We recommend the routine and Gioia Skincare cream best suited to extend the results."],
      ],
      faq: [
        ["Does mesoporation use needles?", "No. The pulses make the skin temporarily more permeable so the applied actives reach deeper."],
        ["Is it uncomfortable or painful?", "No, it is a gentle and pleasant treatment. Many clients find it relaxing."],
        ["When will I see results?", "Skin looks more hydrated and radiant after the first session. With a regular programme, tone and firmness improve too."],
        ["How many sessions do I need?", "It depends on your skin and goal: number and frequency of sessions are defined during your first consultation."],
        ["Can I wear make-up afterwards?", "There is no downtime. In the following hours we suggest avoiding heavy make-up and letting the skin breathe."],
        ["Are there contraindications?", "Some conditions need care: that is why every programme starts with a consultation."],
      ],
    },
  },
  lipolaser: {
    service: { it: "Lipolaser", en: "Lipolaser" },
    img: IMG.realBody,
    pos: "50% 60%",
    it: {
      kicker: "Trattamento corpo",
      title: "Lipolaser",
      lead: "Un percorso di rimodellamento non invasivo per le adiposità localizzate di pancia, fianchi e cosce: per chi cerca una silhouette più definita, proprio dove serve.",
      forWho: ["Cuscinetti su pancia e fianchi", "Adiposità localizzate su cosce e glutei", "Chi cerca un trattamento non invasivo", "Chi vuole rifinire i risultati di uno stile di vita attivo"],
      steps: [
        ["Consulenza", "Analizziamo le zone da trattare e definiamo insieme obiettivi realistici."],
        ["Applicazione", "Le placche vengono posizionate sulle zone scelte: ti rilassi mentre il trattamento lavora."],
        ["Percorso", "Le sedute si susseguono con regolarità per un risultato progressivo."],
        ["Mantenimento", "Ti consigliamo come sostenere i risultati, anche abbinando altri trattamenti corpo."],
      ],
      faq: [
        ["Il lipolaser è doloroso?", "No, è un trattamento non invasivo che si svolge in modo confortevole: la maggior parte delle clienti lo trova rilassante."],
        ["Quante sedute servono?", "Il numero di sedute dipende dalle zone e dall'obiettivo e viene definito durante la prima consulenza."],
        ["Ci sono tempi di recupero?", "No, dopo la seduta puoi tornare subito alle tue attività quotidiane."],
        ["Si può abbinare ad altri trattamenti?", "Sì: l'abbinamento con il trattamento corpo snellente o con un massaggio drenante rende il percorso più completo."],
        ["Ci sono controindicazioni?", "Alcune condizioni richiedono attenzione: per questo ogni percorso inizia con una consulenza in cui raccogliamo tutte le informazioni necessarie."],
      ],
    },
    en: {
      kicker: "Body treatment",
      title: "Lipolaser",
      lead: "A non-invasive body contouring programme for localised fat on the abdomen, hips and thighs: for a more defined silhouette, exactly where you want it.",
      forWho: ["Stubborn areas on belly and hips", "Localised fat on thighs and glutes", "Those looking for a non-invasive treatment", "Refining the results of an active lifestyle"],
      steps: [
        ["Consultation", "We analyse the areas to treat and set realistic goals together."],
        ["Application", "The pads are placed on the chosen areas: you relax while the treatment works."],
        ["Programme", "Sessions follow a regular rhythm for a progressive result."],
        ["Aftercare", "We advise you on how to support your results, including other body treatments."],
      ],
      faq: [
        ["Is lipolaser painful?", "No, it is a non-invasive and comfortable treatment: most clients find it relaxing."],
        ["How many sessions do I need?", "It depends on the areas and your goal, and is defined during your first consultation."],
        ["Is there any downtime?", "No, you can go straight back to your daily activities after the session."],
        ["Can it be combined with other treatments?", "Yes: pairing it with the slimming body treatment or a draining massage makes the programme more complete."],
        ["Are there contraindications?", "Some conditions need care: that is why every programme starts with a consultation."],
      ],
    },
  },
  "depilazione-laser": {
    service: { it: "Depilazione laser", en: "Laser hair removal" },
    img: IMG.realLaser,
    pos: "50% 40%",
    it: {
      kicker: "Epilazione",
      title: "Depilazione laser",
      lead: "Epilazione con laser a diodo per una pelle liscia più a lungo: un percorso a sedute regolari, studiato sul tuo fototipo e sulle zone da trattare.",
      forWho: ["Dire addio a rasoio e ceretta frequenti", "Peli incarniti e irritazioni", "Gambe, inguine, ascelle e viso", "Una pelle liscia e pronta per l'estate"],
      steps: [
        ["Consulenza", "Valutiamo fototipo, tipo di pelo e zone da trattare per definire il percorso."],
        ["Preparazione", "Ti indichiamo come preparare la pelle prima di ogni seduta."],
        ["Seduta", "Il laser a diodo lavora in modo rapido e preciso sulle zone scelte."],
        ["Percorso", "Le sedute si susseguono a intervalli regolari per un risultato progressivo."],
      ],
      faq: [
        ["La depilazione laser fa male?", "La sensazione è ben tollerata dalla maggior parte delle clienti: durante la consulenza ti spieghiamo cosa aspettarti."],
        ["Quante sedute servono?", "Dipende da zona, fototipo e tipo di pelo: il numero di sedute viene definito nella prima consulenza."],
        ["Quando conviene iniziare?", "L'autunno e l'inverno sono il momento ideale: così in primavera arrivi con la pelle già libera."],
        ["Ci sono controindicazioni?", "Alcune condizioni richiedono attenzione: per questo ogni percorso inizia con una consulenza in cui raccogliamo tutte le informazioni necessarie."],
      ],
    },
    en: {
      kicker: "Hair removal",
      title: "Laser hair removal",
      lead: "Diode laser hair removal for smoother skin for longer: a programme of regular sessions designed around your skin type and the areas to treat.",
      forWho: ["Saying goodbye to frequent shaving and waxing", "Ingrown hairs and irritation", "Legs, bikini line, underarms and face", "Smooth skin ready for summer"],
      steps: [
        ["Consultation", "We assess skin type, hair type and areas to define your programme."],
        ["Preparation", "We explain how to prepare your skin before each session."],
        ["Session", "The diode laser works quickly and precisely on the chosen areas."],
        ["Programme", "Sessions follow at regular intervals for a progressive result."],
      ],
      faq: [
        ["Does laser hair removal hurt?", "Most clients tolerate it well: during the consultation we explain what to expect."],
        ["How many sessions do I need?", "It depends on area, skin type and hair type, and is defined during the first consultation."],
        ["When should I start?", "Autumn and winter are ideal, so your skin is already smooth by spring."],
        ["Are there contraindications?", "Some conditions need care: that is why every programme starts with a consultation."],
      ],
    },
  },
  "trattamento-viso-pro-age": {
    service: { it: "Trattamento viso pro-age", en: "Pro-age facial treatment" },
    img: IMG.realFace,
    pos: "50% 25%",
    it: {
      kicker: "Trattamento viso",
      title: "Trattamento viso pro-age",
      lead: "Un trattamento viso professionale che accompagna la pelle nel tempo: più tono, più luminosità e un aspetto riposato, con un protocollo costruito su di te.",
      forWho: ["Pelle che ha perso tono e compattezza", "Prime rughe e linee d'espressione", "Incarnato spento o stanco", "Chi vuole una routine viso professionale"],
      steps: [
        ["Analisi della pelle", "Osserviamo la tua pelle e ascoltiamo cosa desideri migliorare."],
        ["Detersione profonda", "Prepariamo il viso per ricevere al meglio i principi attivi."],
        ["Trattamento", "Applichiamo il protocollo pro-age scelto per te, con manualità e prodotti professionali."],
        ["Routine a casa", "Ti consigliamo i gesti e i prodotti Gioia Skincare per prolungare i risultati."],
      ],
      faq: [
        ["Da che età si può fare?", "Non c'è un'età giusta: il trattamento si adatta allo stato della pelle e agli obiettivi di ciascuna."],
        ["Ogni quanto conviene farlo?", "La frequenza ideale viene definita in consulenza, in base alla pelle e al percorso scelto."],
        ["Si può abbinare alla mesoporazione?", "Sì: la mesoporazione estetica è un ottimo complemento per idratazione e luminosità."],
        ["Posso truccarmi dopo?", "Consigliamo di lasciare respirare la pelle nelle ore successive al trattamento."],
      ],
    },
    en: {
      kicker: "Facial treatment",
      title: "Pro-age facial treatment",
      lead: "A professional facial that supports your skin over time: more tone, more radiance and a rested look, with a protocol built around you.",
      forWho: ["Skin that has lost tone and firmness", "First wrinkles and expression lines", "Dull or tired complexion", "Those wanting a professional facial routine"],
      steps: [
        ["Skin analysis", "We look at your skin and listen to what you want to improve."],
        ["Deep cleansing", "We prepare the face to make the most of the active ingredients."],
        ["Treatment", "We apply the pro-age protocol chosen for you, with expert hands and professional products."],
        ["Home routine", "We recommend the steps and Gioia Skincare products to extend the results."],
      ],
      faq: [
        ["From what age can I do it?", "There is no right age: the treatment adapts to your skin and your goals."],
        ["How often should I do it?", "The ideal frequency is defined during the consultation, based on your skin and programme."],
        ["Can it be combined with mesoporation?", "Yes: aesthetic mesoporation is a great complement for hydration and radiance."],
        ["Can I wear make-up afterwards?", "We suggest letting the skin breathe for a few hours after the treatment."],
      ],
    },
  },
  "trattamento-corpo-snellente": {
    service: { it: "Trattamento corpo snellente", en: "Slimming body treatment" },
    img: IMG.realDark,
    pos: "50% 50%",
    it: {
      kicker: "Trattamento corpo",
      title: "Trattamento corpo snellente",
      lead: "Un percorso corpo per una silhouette più armoniosa e una pelle più tonica: costanza, metodo e un protocollo costruito sulle tue zone critiche.",
      forWho: ["Ritenzione e gonfiore", "Pelle poco tonica su addome, fianchi e cosce", "Inestetismi della cellulite", "Chi vuole un percorso corpo seguito passo passo"],
      steps: [
        ["Consulenza", "Definiamo insieme zone, obiettivi e abitudini."],
        ["Protocollo", "Scegliamo le tecniche più adatte, anche abbinando lipolaser e mesoterapia estetica."],
        ["Sedute", "Le sedute si susseguono con regolarità: la costanza fa la differenza."],
        ["Mantenimento", "Ti diamo i consigli per sostenere i risultati nel tempo."],
      ],
      faq: [
        ["Quante sedute servono?", "Dipende dalle zone e dall'obiettivo: il percorso viene definito nella prima consulenza."],
        ["Si può abbinare ad altri trattamenti?", "Sì: lipolaser, mesoterapia estetica e massaggio rendono il percorso più completo."],
        ["Ci sono tempi di recupero?", "No, dopo la seduta puoi tornare subito alle tue attività."],
        ["Ci sono controindicazioni?", "Alcune condizioni richiedono attenzione: per questo ogni percorso inizia con una consulenza."],
      ],
    },
    en: {
      kicker: "Body treatment",
      title: "Slimming body treatment",
      lead: "A body programme for a more harmonious silhouette and firmer skin: consistency, method and a protocol built around your problem areas.",
      forWho: ["Water retention and bloating", "Lack of tone on abdomen, hips and thighs", "Cellulite", "Those wanting a step-by-step body programme"],
      steps: [
        ["Consultation", "Together we define areas, goals and habits."],
        ["Protocol", "We choose the best techniques, including lipolaser and aesthetic mesotherapy."],
        ["Sessions", "Sessions follow a regular rhythm: consistency makes the difference."],
        ["Aftercare", "We advise you on how to support results over time."],
      ],
      faq: [
        ["How many sessions do I need?", "It depends on the areas and goal: the programme is defined during the first consultation."],
        ["Can it be combined with other treatments?", "Yes: lipolaser, aesthetic mesotherapy and massage make the programme more complete."],
        ["Is there any downtime?", "No, you can go straight back to your day."],
        ["Are there contraindications?", "Some conditions need care: that is why every programme starts with a consultation."],
      ],
    },
  },
  "trattamenti-acne": {
    service: { it: "Trattamenti per l'acne", en: "Acne treatments" },
    img: IMG.cabina,
    pos: "50% 40%",
    it: {
      kicker: "Trattamento viso",
      title: "Trattamenti per l'acne",
      lead: "Un approccio professionale per pelli impure e acneiche, anche in età adulta: pulizia, equilibrio e una routine chiara da seguire a casa.",
      forWho: ["Brufoli, punti neri e pori dilatati", "Acne in età adulta", "Pelle grassa o mista", "Segni e discromie lasciati dalle imperfezioni"],
      steps: [
        ["Analisi della pelle", "Capiamo insieme il tipo di imperfezioni e le possibili cause."],
        ["Pulizia profonda", "Liberiamo la pelle con delicatezza, nel rispetto della sua barriera."],
        ["Trattamento mirato", "Applichiamo attivi specifici per riequilibrare e lenire."],
        ["Routine a casa", "Ti consegniamo una routine semplice per mantenere i risultati."],
      ],
      faq: [
        ["Il trattamento è adatto anche alle adulte?", "Sì: l'acne in età adulta è frequente e richiede un approccio dedicato, che definiamo in consulenza."],
        ["Quante sedute servono?", "Dipende dalla pelle: il percorso viene costruito dopo la prima analisi."],
        ["Devo cambiare la mia routine?", "Ti consigliamo pochi gesti mirati, semplici da seguire ogni giorno."],
        ["Sostituisce il dermatologo?", "No: in caso di acne severa ti consigliamo sempre il confronto con un medico dermatologo."],
      ],
    },
    en: {
      kicker: "Facial treatment",
      title: "Acne treatments",
      lead: "A professional approach for blemish-prone and acne skin, including adult acne: cleansing, balance and a clear routine to follow at home.",
      forWho: ["Spots, blackheads and enlarged pores", "Adult acne", "Oily or combination skin", "Marks and discolouration left by blemishes"],
      steps: [
        ["Skin analysis", "Together we understand the type of blemishes and possible causes."],
        ["Deep cleansing", "We gently clear the skin while respecting its barrier."],
        ["Targeted treatment", "We apply specific actives to rebalance and soothe."],
        ["Home routine", "We give you a simple routine to maintain the results."],
      ],
      faq: [
        ["Is it suitable for adults too?", "Yes: adult acne is common and needs a dedicated approach, defined during the consultation."],
        ["How many sessions do I need?", "It depends on your skin: the programme is built after the first analysis."],
        ["Do I need to change my routine?", "We recommend a few targeted steps, easy to follow every day."],
        ["Does it replace a dermatologist?", "No: for severe acne we always recommend seeing a dermatologist."],
      ],
    },
  },
  massaggio: {
    service: { it: "Massaggio", en: "Massage" },
    img: IMG.realMassage,
    pos: "50% 50%",
    it: {
      kicker: "Benessere",
      title: "Massaggio",
      lead: "Un momento tutto per te: massaggi rilassanti e drenanti per sciogliere le tensioni, alleggerire le gambe e ritrovare il benessere.",
      forWho: ["Stress e tensioni muscolari", "Gambe pesanti e ritenzione", "Un regalo di benessere", "Completare un percorso corpo"],
      steps: [
        ["Accoglienza", "Ci racconti come ti senti e cosa desideri dal massaggio."],
        ["Scelta del massaggio", "Rilassante o drenante: scegliamo insieme la manualità più adatta."],
        ["Massaggio", "Ti rilassi in cabina, in un ambiente caldo e curato."],
        ["Dopo", "Ti lasciamo qualche consiglio per prolungare la sensazione di leggerezza."],
      ],
      faq: [
        ["Che tipi di massaggio fate?", "Massaggi rilassanti e drenanti: in base alle tue esigenze scegliamo insieme quello giusto."],
        ["Si può regalare?", "Sì: puoi regalarlo con un buono regalo online, scegliendo l'importo e scrivendo una dedica."],
        ["Si abbina ad altri trattamenti?", "Il massaggio drenante completa bene i percorsi corpo come lipolaser e mesoterapia estetica."],
        ["Ci sono controindicazioni?", "Alcune condizioni richiedono attenzione: raccontaci sempre il tuo stato di salute prima della seduta."],
      ],
    },
    en: {
      kicker: "Wellbeing",
      title: "Massage",
      lead: "A moment just for you: relaxing and draining massages to release tension, lighten heavy legs and restore wellbeing.",
      forWho: ["Stress and muscle tension", "Heavy legs and water retention", "A wellbeing gift", "Completing a body programme"],
      steps: [
        ["Welcome", "Tell us how you feel and what you want from the massage."],
        ["Choosing the massage", "Relaxing or draining: together we choose the right technique."],
        ["Massage", "You relax in a warm, cared-for treatment room."],
        ["Afterwards", "We leave you a few tips to extend the feeling of lightness."],
      ],
      faq: [
        ["What types of massage do you offer?", "Relaxing and draining massages: we choose the right one together based on your needs."],
        ["Can I give it as a gift?", "Yes: give it with an online gift card, choosing the amount and writing a message."],
        ["Can it be combined with other treatments?", "A draining massage pairs well with body programmes such as lipolaser and aesthetic mesotherapy."],
        ["Are there contraindications?", "Some conditions need care: always tell us about your health before the session."],
      ],
    },
  },
  "manicure-pedicure": {
    service: { it: "Manicure", en: "Manicure" },
    alias: ["Pedicure", "Unghie in acrilico", "Acrylic nails"],
    img: IMG.nails,
    pos: "60% 70%",
    it: {
      kicker: "Mani & Piedi",
      title: "Manicure, pedicure e unghie in acrilico",
      lead: "Mani e piedi curati nei dettagli: manicure, pedicure e ricostruzione unghie in acrilico, con colori e forme scelti insieme a te.",
      forWho: ["Mani curate ogni giorno", "Piedi morbidi e in ordine", "Unghie fragili o corte", "Una nail art per un'occasione speciale"],
      steps: [
        ["Scelta", "Scegliamo insieme forma, lunghezza e colore."],
        ["Preparazione", "Cura delle cuticole e preparazione dell'unghia naturale."],
        ["Applicazione", "Smalto, semipermanente o acrilico, con precisione e cura."],
        ["Mantenimento", "Ti consigliamo ogni quanto tornare per unghie sempre perfette."],
      ],
      faq: [
        ["Quanto dura la ricostruzione in acrilico?", "Dipende dalla crescita dell'unghia: ti indichiamo noi quando fare il refill."],
        ["L'acrilico rovina le unghie?", "Con una corretta applicazione e rimozione in centro, l'unghia naturale viene rispettata."],
        ["Fate anche la pedicure?", "Sì, pedicure estetica per piedi morbidi e curati."],
        ["Come prenoto?", "Online dal sito o su WhatsApp, scegliendo il giorno che preferisci."],
      ],
    },
    en: {
      kicker: "Hands & Feet",
      title: "Manicure, pedicure and acrylic nails",
      lead: "Hands and feet cared for in every detail: manicure, pedicure and acrylic nail extensions, with colours and shapes chosen together with you.",
      forWho: ["Well-groomed hands every day", "Soft, tidy feet", "Brittle or short nails", "Nail art for a special occasion"],
      steps: [
        ["Choice", "Together we choose shape, length and colour."],
        ["Preparation", "Cuticle care and preparation of the natural nail."],
        ["Application", "Polish, gel or acrylic, applied with precision and care."],
        ["Maintenance", "We advise you when to come back for always-perfect nails."],
      ],
      faq: [
        ["How long do acrylic nails last?", "It depends on nail growth: we will tell you when to book a refill."],
        ["Do acrylics damage nails?", "With correct application and in-salon removal, the natural nail is respected."],
        ["Do you also do pedicures?", "Yes, cosmetic pedicures for soft, cared-for feet."],
        ["How do I book?", "Online from the website or on WhatsApp, choosing the day you prefer."],
      ],
    },
  },
};

export const slugForService = (name) =>
  Object.keys(TREATMENTS).find((k) => [...Object.values(TREATMENTS[k].service), ...(TREATMENTS[k].alias ?? [])].includes(name));
